import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { Breakout, semantic } from '@updater/ui-uds';
import { TermsAndPrivacyDisclaimer } from 'components/TermsAndPrivacyDisclaimer';
import { PROVIDER_APP_PLANS_PAGE_TERMS_ACCEPTANCE_FOOTER } from 'constants/experiments';

// Sticky so it stays pinned to the viewport bottom while scrolling plan
// cards, but naturally releases once the sibling InnerFooter/Footer
// components are reached.
export function TermsAcceptanceFooter() {
  const isEnabled = useFeatureIsOn(
    PROVIDER_APP_PLANS_PAGE_TERMS_ACCEPTANCE_FOOTER.NAME
  );
  if (!isEnabled) {
    return null;
  }

  return (
    <Breakout
      // 100vw can exceed the real visible viewport (document.clientWidth)
      // by the scrollbar's width, which otherwise leaves this full-bleed
      // bar a few px wider than the page, creating horizontal scroll
      // capacity. Capping it 20px under 100vw comfortably clears that
      // gap with a visually-imperceptible inset, without touching any
      // ancestor's overflow (which would clip this same full-bleed
      // extension on wide viewports where PageContent centers itself).
      breakoutLimit="calc(100vw - 20px)"
      position="sticky"
      bottom="0"
      zIndex="navigation"
      backgroundColor={semantic.surface.subtle}
      borderY={`1px solid ${semantic.border.color.default}`}
      py="s"
      px="m"
      textAlign="center"
    >
      <TermsAndPrivacyDisclaimer
        prefix='By clicking "Select,"'
        variant="s"
        color={semantic.action.secondary.text}
      />
    </Breakout>
  );
}
